const { types } = require("mobx-state-tree");
const {
  baseConfig,
  getConfig,
  getOutFields,
} = require("../../constants/config");

const Config = types
  .model({
    name: "",
  })
  .actions((self) => ({
    setConfig: (name) => {
      self.name = name;
    },
    getConfig: () => getConfig(self.name),
    getOutfields: () => getOutFields(self.name),
  }));

export const configStore = Config.create();
